// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleQueryPackEditor = {
  id: "query-pack-editor",
  mrn: "//iam.api.mondoo.app/roles/query-pack-editor",
  title: "Query Pack Editor",
  allowedActions,
} as const;

export type RoleQueryPackEditor = typeof roleQueryPackEditor;
